<template>
    <div class="msgBox">
        <form @submit="handleSubmit" ref="myForm">
            <h2>来 , 说说你在做什么 , 想什么</h2>
            <div>
                <input id="userName" class="f-text" v-model="username" ref="username" :class="{active:isusernameAcitve}"
                @focus="handleuserNameFocus"
                @blur="handleuserNameBlur"
                />
                <p id="face">
                    <img v-for="(pic, index) in pics" :key="pic.src" :src="pic.src" :class="[{current:pic.isActive},{hover:pic.isOver}]"
                    @mouseover="handleImgOver(pic)"
                    @mouseout="handleImgOut(pic)"
                    @click="handleImgClick(index)"
                    >
                </p>
            </div>
            <div><textarea id="conBox" class="f-text" v-model="conbox" ref="conbox" :class="{active:isconboxActive}"
            
            @blur="hadnleconboxBlur" 
            @keyup="confine"           
            @focus="confine"
            @change="confine"

            ></textarea></div>
            <div class="tr">
                <p>
                    <span class="countTxt">{{countTxt}}</span><strong :class="[{maxNumColor:isMaxNumActive},maxNum]">{{maxNum}}</strong><span>个字</span>
                    <input @click="handleSend" id="sendBtn" type="button" value="" title="快捷键 Ctrl+Enter"
                    @mouseover="handleSendOver"  :class="{hover:isSendActive}"
                    @mouseout="handleSendOut"
                    />
                </p>
            </div>
        </form>
        <div class="list">
            <h3><span>大家在说</span></h3>
            <ul>
                <template v-if="lists.length">
                <li v-for="(list,index) in lists" :key="index" :class="{hover:list.isLiActive}"
                @mouseover="handleLiover(index)"
                @mouseout="handleLiout"
                >
                    <div class="userPic"><img :src="list.src"/></div>
                    <div class="content">
                        <div class="userName"><a href="#">{{list.username}}</a></div>
                        <div class="msgInfo">{{list.msg}}</div>
                        <div class="times"><span>{{list.times}}</span><a @click="handleDelLi(index)" class="del" v-show="list.isLiActive" href="#">删除</a></div>
                    </div>
                </li>
                </template>
            </ul>
        </div>
    </div>
</template>
<script>
import {lists, pics} from './components/lists';
function format(str){
    return str.toString().replace(/^(\d)$/,'0$1');
}
export default {
    name:'Navs',
    data(){
        return{
            pics:pics,
            lists:lists,
            username:'',
            conbox:'',
            bSend:false,
            isusernameAcitve:false,
            isconboxActive:false,
            maxNum:140,
            countTxt:'还能输入',
            isMaxNumActive:false,
            isSendActive:false
        }
    },
    methods:{
        handleDelLi(index){
            this.lists.splice(index,1)
        },
        handleLiover(index){
            for(var i=0;i<this.lists.length;i++) this.lists[i].isLiActive=false;
            this.lists[index].isLiActive=true;
        },
        handleLiout(){
            for(var i=0;i<this.lists.length;i++) this.lists[i].isLiActive=false;
        },
        handleSendOver(){
            this.isSendActive=true;
        },
        handleSendOut(){
            this.isSendActive=false;
        },
        handleuserNameFocus(){
            this.isusernameAcitve=true;
        },
        handleuserNameBlur(){
            this.isusernameAcitve=false;
        },
        
        hadnleconboxBlur(){
            this.isconboxActive=false;
        },
        confine(){
            this.isconboxActive=true;
            var len=0;
            for(var i=0;i<this.conbox.length;i++) len += /[^\x00-\xff]/g.test(this.conbox.charAt(i)) ? 1 : 0.5;
            this.maxNum = Math.abs(140 - Math.floor(len));
            140 - Math.floor(len) >= 0 ? (this.isMaxNumActive=false,this.countTxt='还能输入',this.bSend=true) :(this.isMaxNumActive=true, this.countTxt='已超出',this.bSend=false);
        },
        handleImgOver(pic){
            pic.isOver=true;
        },
        handleImgOut(pic){
            pic.isOver=false;
        },
        handleImgClick(index){
            for(var i=0; i<this.pics.length;i++) this.pics[i].isActive=false;
            this.pics[index].isActive=true;
        },
        handleSubmit(){
            return false;
        },
        handleSend(){
            var reg=/^\s*$/g;
            if(reg.test(this.username)){
                alert("\u8bf7\u586b\u5199\u60a8\u7684\u59d3\u540d");
                this.$refs.username.focus()
            }
            else if(!/^[u4e00-\u9fa5\w]{2,8}$/g.test(this.username)){
                alert("\u59d3\u540d\u75312-8\u4f4d\u5b57\u6bcd\u3001\u6570\u5b57\u3001\u4e0b\u5212\u7ebf\u3001\u6c49\u5b57\u7ec4\u6210\uff01");
                this.$refs.username.focus()
            }
            else if(reg.test(this.conbox)){
                alert("\u968f\u4fbf\u8bf4\u70b9\u4ec0\u4e48\u5427\uff01");
                this.$refs.conbox.focus()
            }
            else if(!this.bSend){
                alert("\u4f60\u8f93\u5165\u7684\u5185\u5bb9\u5df2\u8d85\u51fa\u9650\u5236\uff0c\u8bf7\u68c0\u67e5\uff01");
                this.$refs.conbox.focus()
            }
            else{
                var date = new Date();
                var mySrc = '';
                for(var i=0;i<this.pics.length;i++){
                    if(this.pics[i].isActive)
                    mySrc =this.pics[i].src;
                }
                this.lists.unshift({
                src:mySrc,
                username:this.username,
                msg:this.conbox,
                times:format(date.getMonth() + 1) + '\u6708' + format(date.getDate()) + '\u65e5 ' + format(date.getHours()) + ':' + format(date.getMinutes()),
                isLiActive:false
                });
                this.username='';
                this.conbox='';
                for(var i=0;i<this.pics.length;i++) this.pics[i].isActive=false;
                this.pics[0].isActive=true;
            }
        },
        handleDocKeyup(){
            event.ctrlKey && event.keyCode == 13 && this.handleSend()
        }
    },
    mounted(){
        document.addEventListener('keyup',this.handleDocKeyup);
        this.confine();
    }
}
</script>
<style>
body,div,h2,h3,ul,li,p{
    margin: 0;
    padding: 0;
}
a{
    text-decoration: none;
}
a:hover{
    text-decoration: underline;
}
ul{
    list-style-type: none;
}
body{
    color: #333;
    background: #3c3a3b;
    font: 12px/1.5 \5b8b\4f53;
}
.msgBox{
    width: 500px;
    background: #fff;
    border-radius: 5px;
    margin: 10px auto;
    padding-top: 10px;
}
.msgBox form h2{
    font-weight: 400;
    font: 400 18px/1.5 \5fae\8f6f\96c5\9ed1;
}
.msgBox form{
    background: url(./assets/lesson6/boxBG.jpg) repeat-x 0 bottom;
}
#userName, #conBox{
    color: #777;
    border: 1px solid #d0d0d0;
    border-radius: 6px;
    background: #fff url(./assets/lesson6/inputBG.png) repeat-x;
    padding: 3px 5px;
    font: 14px/1.5 arial;
}
#userName.active, #conBox.active{
    border: 1px solid #7abb2c;
}
#userName{
    height: 20px;
}
#conBox{
    width: 448px;
    resize: none;
    height: 65px;
    overflow: auto;
}
.msgBox form div{
    position: relative;
    color: #999;
    margin-top: 10px;
}
.msgBox img{
    border-radius: 3px;
}
#face{
    position: absolute;
    top:0;
    left: 172px;
}
#face img{
    width: 30px;
    height: 30px;
    cursor: pointer;
    margin-right: 6px;
    opacity: 0.5;
    filter: alpha(opacity=50);
}
#face img.hover, #face img.current{
    width: 28px;
    height: 28px;
    border: 1px solid #f60;
    opacity: 1;
    filter: alpha(opacity=100);
}
#sendBtn{
    border: 0;
    width: 112px;
    height: 30px;
    cursor: pointer;
    margin-left: 10px;
    background: url(./assets/lesson6/btn.png) no-repeat;
}
#sendBtn.hover{
    background-position: 0 -30px;
}
.msgBox form .maxNum{
    font: 26px/30px Georgia, Tahoma, Arial;
    padding: 0 5px;
}
.msgBox form .maxNumColor{
    color:#f60;
}
.msgBox .list{
    padding: 10px;
}
.msgBox .list h3{
    position: relative;
    height: 33px;
    font-size: 14px;
    font-weight: 400;
    background: #e3eaec;
    border: 1px solid #dee4e7;
}
.msgBox .list h3 span{
    position: absolute;
    left: 6px;
    top:6px;
    background: #fff;
    line-height: 28px;
    display: inline-block;
    padding: 0 15px;
}
.msgBox .list ul{
    overflow: hidden;
    zoom: 1;
}
.msgBox .list ul li{
    float: left;
    clear: both;
    width: 100%;
    border-bottom: 1px dashed #d8d8d8;
    padding: 10px 0;
    background: #fff;
    overflow: hidden;
}
.msgBox .list ul li.hover{
    background: #f5f5f5;
}
.msgBox .list .userPic{
    float: left;
    width: 50px;
    height: 50px;
    margin-left: 10px;
    border: 1px solid #ccc;
    border-radius: 3px;
}
.msgBox .list .content{
    float: left;
    width: 400px;
    font-size: 14px;
    margin-left: 10px;
    font-family: arial;
    word-wrap: break-word;
}
.msgBox .list .userName{
    display: inline;
    padding-right: 5px;
}
.msgBox .list .userName a{
    color: #2b4a78;
}
.msgBox .list .msgInfo{
    display: inline;
    word-wrap: break-word;
}
.msgBox .list .times{
    color: #889db6;
    font: 12px/18px arial;
    margin-top: 5px;
    overflow: hidden;
    zoom: 1;
}
.msgBox .list .times span{
    float: left;
}
.msgBox .list .times a{
    float: right;    
    color: #889db6;
    
}
.tr{
    overflow: hidden;
    zoom: 1;
}
.tr p{
    float: right;
    line-height: 30px;
}
.tr *{
    float: left;
}

</style>
